<template>
  <div>
    <v-container fill-height fluid>
    <v-row>
      <v-flex xs3 class="mr-2">
        <Search
          v-model="filters.search"
          :label="$t('SEARCH')"
          prepend-icon="search"
          :delay="500"
        />
      </v-flex>
      <v-flex xs3 class="mr-2">
        <Search
          v-model="filters.numero_bolla"
          :label="$t('fields.numero_bolla')"
          prepend-icon="search"
          :delay="500"
        />
      </v-flex>
      <v-spacer></v-spacer>
      <v-btn
        v-if="can('manage warehouses_load')"
        @click="showWarehouseLoadModal(0)"
        color="primary"
        dark
        class="mb-2 mr-2"
      >{{ $t("NEW") }}
      </v-btn>
      <v-btn
        v-if="can('manage warehouses_load')"
        :to="{path: `/warehouses/${warehouse.id}/import-load`}"
        color="primary"
        dark
        class="mb-2 mr-2"
      >{{ $t("IMPORT") }}
      </v-btn>
    </v-row>
    </v-container>
    <v-data-table
      :headers="headers"
      :items="items"
      :server-items-length="totalItems"
      :no-data-text="$t('NO_DATA')"
      :no-results-text="$t('NO_DATA')"
      hide-default-footer
      :options.sync="pagination"
      :loading="loading"
      class="elevation-1"
    >

      <template v-slot:item.options.name="{ item }">
            {{ (item.options && item.options.name) ? item.options.name.toUpperCase() : '' }}
      </template>

      <template v-slot:item.created_at="{ item }">
            {{ item.created_at | timeFormat }}
      </template>

      <template v-slot:item.actions="{ item }">
            <v-layout row wrap></v-layout>
      </template>
    </v-data-table>
    <div class="text-xs-center pt-2">
      <Paginator
        :total-items="totalItems"
        :page.sync="pagination.page"
        :items-per-page.sync="pagination.itemsPerPage"
        @change="fetchWarehouseLoad"
      />
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';

  import { warehousesService } from '../../../utils/services/warehouses.service';
  import WarehouseLoadModal from '../../modals/WarehousesLoad/WarehouseLoadModal';

  import Search from '../../shared/Inputs/Search.vue';
  import Paginator from '../../shared/Paginator';

  export default {
    name: 'WarehouseLoadDetails',
    components: { Search, Paginator },
    props: {
      warehouse: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        loading: false,
        items: [],
        filters: {
          search: '',
          numero_bolla: '',
        },
        totalItems: 0,
        pagination: {
          page: 1,
          itemsPerPage: 10,
          sortDesc: [false],
          sortBy: ['created_at'],
        },
        headers: [
          {
            text: this.$t('fields.id'),
            align: 'left',
            value: 'id',
          },
          { text: this.$t('fields.sku'), value: 'options.sku' },
          { text: this.$t('fields.name'), value: 'options.name' },
          { text: this.$t('fields.quantity'), value: 'options.qty', sortable: false },
          { text: this.$t('fields.numero_bolla'), value: 'options.numero_bolla', sortable: false },
          { text: this.$t('fields.created_at'), value: 'created_at' },
          { text: this.$t('fields.actions'), value: 'actions', sortable: false, align: 'center' },
        ],
      };
    },
    computed: {
      requestFilters() {
        const filters = {};
        if (this.pagination.sortBy.length === 1 && this.pagination.sortDesc.length === 1) {
          const { sortBy, sortDesc } = this.pagination;
          filters.sortBy = sortBy;
          filters.sortDesc = sortDesc;
        }
        filters.search = this.filters.search;
        filters.numero_bolla = this.filters.numero_bolla;
        return filters;
      },
    },
    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('modal', ['showModal', 'hideModal']),
      ...mapActions('alert', ['showToast']),

      async showWarehouseLoadModal(id) {
        this.showModal({
            component: WarehouseLoadModal,
            data: {
              stored: {
                id,
                warehouse_id: this.warehouse.id,
              },
          },
          options: {
            title: this.$t('LOAD'),
            onSave: (
              form,
              error,
            ) => warehousesService.saveLoad(this.warehouse.id, form)
            .then(() => {
              this.fetchWarehouseLoad(this.pagination.page);
              this.hideModal({});
              this.showToast({ type: 'success', message: this.$t('SAVED') });
            })
            .catch(error => {
              this.handleError(error, this.errors);
            })
            .finally(() => {
              this.fetchWarehouseLoad(this.pagination.page);
            }),
          },
        });
      },

      async fetchWarehouseLoad(forcePage) {
        this.loading = true;
        const { page, itemsPerPage } = this.pagination;
        return warehousesService.load(this.warehouse.id, {
          page: page || forcePage || 1,
          itemsPerPage,
          filters: this.requestFilters,
        })
        .then((response) => {
            this.items = response.data.data;
            this.totalItems = response.data.meta.total;
            this.pagination = this.getPagination(
              response.data.meta,
              { oldPagination: this.pagination, forcePage },
            );
        })
        .catch(error => {
          this.handleError(error, this.errors);
        })
        .finally(() => {
          this.loading = false;
        });
      },
    },
    async created() {
      await this.fetchWarehouseLoad();
    },
    watch: {
      filters: {
        deep: true,
        handler() {
          this.fetchWarehouseLoad(1);
        },
      },
      'pagination.sortBy': {
        handler(oldVal, newVal) {
          if (newVal !== oldVal) {
            this.fetchWarehouseLoad(1);
          }
        },
      },
    },
  };
</script>
